import { Component, Input, OnInit } from '@angular/core';
/**
  Componente que muestra mensajes de error para un campo de formulario.
  Este componente permite mostrar mensajes de error personalizados para campos de formulario,
  como errores de campo requerido o errores de patrón no válido. También permite agregar clases
  CSS personalizadas para estilizar el mensaje de error.
**/
@Component({
    selector: 'app-form-error-message',
    templateUrl: './form-error-message.component.html',
    styleUrls: ['./form-error-message.component.scss'],
    standalone: false
})
export class FormErrorMessageComponent implements OnInit {

  /**
    Clase CSS personalizada que se aplicará al contenedor del mensaje de error.
    @type {string}
  **/
    @Input() className = '';

    /**
      Campo de formulario asociado al mensaje de error.
      @type {any}
    **/
    @Input() fieldInput: any;
  
    /**
      Mensaje de error que se muestra cuando el campo es requerido y no se ha completado.
      @type {string}
    **/
    @Input() errorRequired = '';
  
    /**
      Mensaje de error que se muestra cuando el valor del campo no cumple con el patrón especificado.
      @type {string}
    **/
    @Input() errorPattern = '';

  constructor() { }

  ngOnInit() {
  }

}
